import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-euro",
  templateUrl: "./med-icon-euro.component.html",
})
export class MedIconEuroComponent extends SvgMixinComponent {}
